<template>
    <div class="f-item__quantity">
        <div class="quantity">
            <button class="quantity__minus" @click="decrease">-</button>
            <input class="quantity__input" type="number" @change="validateQuantity" v-model="quantity" min="1" max="500" step="1">
            <button class="quantity__plus" @click="increase">+</button>
        </div>
        <a class="btn--basket" href="javascript:void(0);" @click="ADD_BASKET_ITEM({id:id, quantity:quantity})"></a>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name  : "FavoritesButtons",
    props: ['id'],
    data() {
        return {
            quantity: 1
        }
    },
    methods: {
        ... mapActions([
            'ADD_BASKET_ITEM'
        ]),
        async increase() {
            if(this.quantity >= 500)
                return;
            this.quantity++;
        },
        async decrease() {
            if(this.quantity <= 1)
                return;
            this.quantity--;
        },
        async validateQuantity(event) {
            if(!isNaN(parseInt(event.target.value)) && parseInt(event.target.value) > 0 && parseInt(event.target.value) <= 500)
                this.quantity = event.target.value;
            else
                event.target.value = 1;
        },
    },
}
</script>

<style scoped>

</style>